/* =========================================================
   SAVANNA — Shopify theme interactions
   ========================================================= */
(function () {
  'use strict';

  /* ---- Header shrink on scroll ---- */
  var header = document.getElementById('siteHeader');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- Mobile menu ---- */
  var burger = document.getElementById('burger');
  var mobileNav = document.getElementById('mobileNav');
  if (burger && mobileNav) {
    var toggleNav = function (force) {
      var open = (force === undefined) ? !burger.classList.contains('open') : force;
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileNav.classList.toggle('open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    burger.addEventListener('click', function () { toggleNav(); });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { toggleNav(false); });
    });
  }

  /* ---- Scroll reveal ---- */
  var reveals = document.querySelectorAll('.reveal, .reveal-img');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- Count-up stats ---- */
  var counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window && counters.length) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, target = parseFloat(el.dataset.count), dur = 1500, start = null;
        var step = function (t) {
          if (start === null) start = t;
          var p = Math.min((t - start) / dur, 1), eased = 1 - Math.pow(1 - p, 3), val = target * eased;
          el.textContent = Number.isInteger(target) ? Math.floor(val).toLocaleString() : val.toFixed(1);
          if (p < 1) requestAnimationFrame(step); else el.textContent = target.toLocaleString();
        };
        requestAnimationFrame(step);
        cio.unobserve(el);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (c) { cio.observe(c); });
  }

  /* ---- Parallax ---- */
  var par = document.querySelectorAll('[data-parallax]');
  if (par.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var ticking = false;
    var update = function () {
      var y = window.scrollY;
      par.forEach(function (el) {
        var speed = parseFloat(el.dataset.parallax) || 0.15;
        el.style.transform = 'translate3d(0,' + (y * speed) + 'px,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* ---- Collection filter chips (client-side) ---- */
  var chips = document.querySelectorAll('.chip[data-filter]');
  var cards = document.querySelectorAll('.card[data-cat]');
  if (chips.length && cards.length) {
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        var f = chip.dataset.filter;
        cards.forEach(function (card) {
          var show = f === 'all' || (card.dataset.cat || '').split(' ').indexOf(f) > -1;
          card.style.display = show ? '' : 'none';
        });
      });
    });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.faq').forEach(function (faq) {
    var q = faq.querySelector('.faq__q');
    var a = faq.querySelector('.faq__a');
    if (q) q.addEventListener('click', function () {
      var open = faq.classList.toggle('open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
    });
  });

  /* =========================================================
     CART  (drawer + ajax add)
     ========================================================= */
  var drawer = document.getElementById('cartDrawer');

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }
  function openDrawer() { if (drawer) { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('open'); document.body.style.overflow = ''; } }

  var toastTimer;
  function showToast(message) {
    var el = document.getElementById('cartToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cartToast';
      el.className = 'cart-toast';
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  function renderDrawerHTML(html) {
    if (!html || !drawer) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('.cart-drawer__inner');
    var current = drawer.querySelector('.cart-drawer__inner');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }
  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawerHTML(data['cart-drawer']); })
      .catch(function () {});
  }

  function changeLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return refreshDrawer(); });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.classList.contains('cart-drawer__overlay')) { closeDrawer(); return; }
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.getAttribute('data-line'), 0); return; }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var cur = parseInt(step.getAttribute('data-current'), 10);
      var dir = parseInt(step.getAttribute('data-qty-step'), 10);
      changeLine(step.getAttribute('data-line'), Math.max(0, cur + dir));
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---- Ajax add-to-cart ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { updateCartCount(cart.item_count); return refreshDrawer(); })
      .then(function () { showToast('カートに追加しました'); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  });
})();
